import React from 'react';
import BorderText from '../border-text/border-text';
interface TimeBlockProps {
  time: string;
  day: string;
  date: string;
  location: string;
}

export const TimeBlock: React.FC<TimeBlockProps> = ({location, time, day, date}) => {
  const gradientClass =
    'bg-[linear-gradient(to_right,rgba(53,70,255,0)_0%,rgba(19,57,246,0.63)_26%,rgba(0,38,227,0.9)_53%,rgba(11,48,232,0.5)_78%,rgba(55,40,255,0)_100%)]';

  return (
    // Bỏ background cũ, sắp xếp theo chiều dọc
    <div className={`my-6 flex flex-col items-center gap-3 font-bold ${gradientClass} py-4`}>
      {/* Dòng địa điểm */}
      <BorderText as={'h3'} text={location} className={`!font-montserrat text-base md:text-4xl font-extrabold uppercase tracking-wider`} />

      {/* Khối thời gian */}
      <div className="flex items-center gap-1">
        <BorderText as={'span'} text={time} className={`font-montserrat text-6xl md:text-7xl`} />
        <div
          className={`flex flex-col items-start border-l-2 border-white/80 pl-1 text-lg leading-tight`}>
          <BorderText as={'span'} text={day} className="font-montserrat text-base md:text-xl font-extrabold" />
          <BorderText as={'span'} text={date} className="font-montserrat text-base md:text-xl font-extrabold" />
        </div>
      </div>
    </div>
  );
};
